import { createLogger } from 'common/log'
import { SEARCH_FE_TOGGLES_TO_DATA_LAYER } from 'common/constants'

const logger = createLogger('gtmEvents')

const formatFilterEventData = ({ name, value, type, filterPosition }) => {
  const formattedData = {
    filter_category: name,
    filter_name: cleanValue(value, type)
  }
  if (filterPosition) formattedData.filter_position = filterPosition
  return formattedData
}
export const filterApplied = withTryCatch(filterActionData => {
  pushToDatalayer({ event: 'filter_applied', ...formatFilterEventData(filterActionData) })
})

export const filterRemoved = withTryCatch(filterActionData => {
  pushToDatalayer({ event: 'filter_removed', ...formatFilterEventData(filterActionData) })
})

export const pushAllFiltersEvent = withTryCatch(action => {
  pushToDatalayer({ event: 'all_filters', action })
})

export const sortChanged = withTryCatch(value => {
  pushToDatalayer({ event: 'filter_applied', filter_category: 'sorteren op', filter_name: mapSortingValues(value) })
})

const mapSortingValues = value => {
  if (value === 'price') return 'price-desc'
  return value
}

const cleanValue = (value, type) => {
  return value.replaceAll('"', '')
}

export function pushToDatalayer(e) {
  window?.dataLayer?.push(e)
}

export const pushFlagToDatalayer = ({ ldFlag, ldVariation, ...rest }) => {
  pushToDatalayer({
    event: 'ldFlaggedFeature',
    ldFlag,
    ldFlagStatus: !!ldVariation,
    ldVariation,
    ...rest
  })
}

export const getFlagsToGA = ldFlags => {
  const togglesToDatalayer = ldFlags[SEARCH_FE_TOGGLES_TO_DATA_LAYER]
  if (!togglesToDatalayer?.length) return false
  const togglesList = togglesToDatalayer?.split(',')
  if (!Array.isArray(togglesList)) return false

  const flagsToGA = {}
  togglesList.forEach(toggleRaw => {
    const toggle = toggleRaw.trim()
    if (Object.hasOwn(ldFlags, toggle)) {
      flagsToGA[toggle] = ldFlags[toggle]
    }
  })
  return flagsToGA
}

export const isFlagPushedToDataLayer = flag => window?.dataLayer?.findIndex(({ ldFlag }) => ldFlag === flag) >= 0

export const isFlagInGA = ({ flagsToGA, ldFlag }) => Object.keys(flagsToGA || {}).includes(ldFlag)

function withTryCatch(func) {
  return (...args) => {
    try {
      return func(...args)
    } catch (error) {
      logger.error(error)
    }
  }
}
